import { createFileRoute } from '@tanstack/react-router';
import { SignUp } from '@/pages';

/**
 * Sign Up Route
 * Public route for user registration
 */
export const Route = createFileRoute('/_public/signup')({
  component: SignUp,
});
